import React from 'react'
import { history } from '../store'

class ObjectiveList extends React.Component {
  goTo(customer, year, e) {
    history.push(`/objectives/${customer}?year=${year}`)
  }

  progressBar(actual, objective) {

    const percentage = objective > 0 ? (actual / objective) * 100 : 0;
    const barWidth = Math.min(percentage, 100);

    let color = "warning"

    if (percentage < 50) {
      color = "danger"
    } else if (percentage >= 100) {
      color = "success"
    }

    return (
      <div className="obj-progress-container">
        <div className={`obj-progress-bar ${color}`} style={{ width: `${barWidth}%` }}></div>
        <div className="obj-progress-percentage">{percentage.toFixed(2)}%</div>
      </div>
    );
  }

  calculateTotalObjective(objective) {

    const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    const weeks = ['W1', 'W2', 'W3', 'W4', 'W5', 'W6'];

    let totalObjectives = 0;

    {
      months.map((month) => {
        weeks.map(week => (
          totalObjectives += objective[month][week]

        ))
      }
      )
    }

    return totalObjectives
  }

  calculateTotalReal(objective) {
    const salesArqueos = Array.isArray(this.props.salesArqueos)
      ? this.props.salesArqueos
      : [];

    const customerId = objective.Customer._id;
    const filteredArqueos = salesArqueos.filter(arqueo => {
      const cid = (arqueo.CustomerId || arqueo.Customer || '') + '';
      return cid === customerId;
    });

    let totalReal = 0;

    filteredArqueos.forEach((arqueo) => {
      totalReal += Number(arqueo.GMV_net || 0);
    });

    return totalReal
  }

  getCustomersWithoutObjectives() {
    const salesArqueos = Array.isArray(this.props.salesArqueos)
      ? this.props.salesArqueos
      : [];
    const objectives = this.props.objectives || [];

    const objectiveCustomerIds = new Set(
      objectives.map(o => (o.Customer._id || '') + '')
    );

    const customerMap = {};
    salesArqueos.forEach(arqueo => {
      const cid = (arqueo.CustomerId || arqueo.Customer || '') + '';
      if (objectiveCustomerIds.has(cid)) return;
      if (!customerMap[cid]) {
        customerMap[cid] = {
          id: cid,
          name: arqueo.CustomerName || arqueo.Fullname || cid,
          total: 0,
        };
      }
      customerMap[cid].total += Number(arqueo.GMV_net || 0);
    });

    return Object.values(customerMap)
      .filter(c => c.total > 0)
      .sort((a, b) => a.name.localeCompare(b.name));
  }

  render() {
    const customersWithoutObj = this.getCustomersWithoutObjectives();
    const sortedObjectives = [...this.props.objectives].sort((a, b) =>
      a.Customer.Fullname.localeCompare(b.Customer.Fullname)
    );

    return (
      <>
        {/* Desktop list header */}
        <div className="obj-admin-list-header">
          <div className="obj-header-col col-customer">Cliente</div>
          <div className="obj-header-col col-year">Año</div>
          <div className="obj-header-col col-real">Real</div>
          <div className="obj-header-col col-objective">Objetivo</div>
          <div className="obj-header-col col-progress">Progreso</div>
          <div className="obj-header-col col-status">Estado</div>
        </div>

        {/* Card list */}
        <div className="obj-admin-objective-list">
          {sortedObjectives.map(objective => {
            const date = (new Date(objective.TimeStamp)).getFullYear()
            const totalReal = this.calculateTotalReal(objective)
            const totalObjective = this.calculateTotalObjective(objective)

            return (
              <div key={objective.number}
                className="obj-admin-objective-card"
                onClick={e => this.goTo(objective.Customer._id, date, e)}>
                <div className="obj-admin-objective-row">
                  <div className="obj-admin-col col-customer">
                    <span className="obj-customer-name">{objective.Customer.Fullname}</span>
                  </div>
                  <div className="obj-admin-col col-year">{date}</div>
                  <div className="obj-admin-col col-real">{totalReal.toFixed(2)} €</div>
                  <div className="obj-admin-col col-objective">{totalObjective.toFixed(2)} €</div>
                  <div className="obj-admin-col col-progress">{this.progressBar(totalReal, totalObjective)}</div>
                  <div className="obj-admin-col col-status">
                    {totalReal >= totalObjective ? (
                      <span className="obj-status-badge achieved"><i className="fas fa-check-circle"></i> Alcanzado</span>
                    ) : (
                      <span className="obj-status-badge pending"><i className="fas fa-clock"></i> Pendiente</span>
                    )}
                  </div>
                </div>
              </div>
            )
          })}

          {/* Customers with sales but no objectives */}
          {customersWithoutObj.map(customer => (
            <div key={customer.id}
              className="obj-admin-objective-card obj-no-objective-card">
              <div className="obj-admin-objective-row">
                <div className="obj-admin-col col-customer">
                  <span className="obj-customer-name">{customer.name}</span>
                </div>
                <div className="obj-admin-col col-year">—</div>
                <div className="obj-admin-col col-real">{customer.total.toFixed(2)} €</div>
                <div className="obj-admin-col col-objective">—</div>
                <div className="obj-admin-col col-progress">—</div>
                <div className="obj-admin-col col-status">
                  <span className="obj-status-badge neutral"><i className="fas fa-minus-circle"></i> Sin objetivo</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </>
    )
  }
}

export default ObjectiveList

